// Module 5 / Slice 5 — Rota detail Pattern tab.
//
// Lists rota_pattern rows for the current rota. The cycle-grid editor +
// preview modal are carry C-mod5-10 (Phase 4 hardening); v1 shows pattern
// summary rows so M7's schedule-generator team can spot pattern shape.

import type { components } from "../../../api/rota-config.gen";
import { useI18n } from "../../../i18n/I18nContext";

type RotaPattern = components["schemas"]["RotaPattern"];

export function PatternTab({
  rotaId,
  patterns,
}: {
  rotaId: string;
  patterns: readonly RotaPattern[];
}): JSX.Element {
  const { t } = useI18n();
  if (patterns.length === 0) {
    return (
      <p data-testid={`pattern-tab-empty-${rotaId}`}>
        {t("rota_config.patterns.empty")}
      </p>
    );
  }
  return (
    <table className="rc-table" data-testid="pattern-tab-table">
      <thead>
        <tr>
          <th>{t("rota_config.patterns.col.name")}</th>
          <th>{t("rota_config.patterns.col.kind")}</th>
          <th>{t("rota_config.patterns.col.cycleLengthDays")}</th>
          <th>{t("rota_config.patterns.col.shiftCount")}</th>
          <th>{t("rota_config.patterns.col.anchorDate")}</th>
        </tr>
      </thead>
      <tbody>
        {patterns.map((p) => (
          <tr key={p.id} data-testid={`pattern-row-${p.id}`}>
            <td>{p.name}</td>
            <td>{p.patternKind}</td>
            <td>{p.cycleLengthDays}</td>
            <td>{p.shiftCount}</td>
            <td>{p.anchorDate ?? "—"}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
